import _ from "lodash";
import moment from "moment";
import axios from "axios";

import Endpoint from "../../constant/endpoint";

const token =
  "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIyIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwNzA2NTcyLCJleHAiOjI3MjY2ODA3MjM0NTcyLCJqdGkiOiIxNGNjNzI3Ny1kODg4LTQwZGUtODZkZi1iNDkzY2RhMzYzNTgifQ.1uhBK4cq-QhM_w21B2iPQLrPWB6kpf5l-fJt4iROO6E";
const token2 =
  "eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiIxIiwic2NwIjoidXNlciIsImF1ZCI6bnVsbCwiaWF0IjoxNjAwODM3NTM3LCJleHAiOjI3MjY2ODA3MzY1NTM3LCJqdGkiOiI3Y2E2NzYwNC1lN2UwLTQ0ZWUtYjY1Ny0wM2EzMDkyNWMwMzcifQ.9YLNDUd2DO6qnlnGfyrdzQRGaeFBE2adWcHWaEV-z_0";

const state = {
  loading: false,
  error: {},
  data: [],
  focusId: null,
  mpTanker: {},
  mpVessel: [],
  mpTankerCapacity: [],
  mpTankerAll: [],
  mpTankerValue: [],
  mpVesselAll: []
};

const getters = {
  getCapacity: (state) => () => {
    const capacity = _.get(state, "mpTanker.capacity", 0);
    if (capacity == null) return 0;
    return capacity;
  },
  getTransferValue: (state) => () => {
    const { mpTankerCapacity } = state;
    const capacity = _.last(mpTankerCapacity);
    const value = _.get(capacity, "total_transfer", 0);
    if (value == null) return 0;
    return Math.abs(value);
  },
  getTankerAll: (state) => {
    return state.mpTankerAll; 
  },
  getTankerbyMMSI: (state) => (mmsi)=> {
    return _.find(state.mpTankerAll,{"mmsi": mmsi}); 
  },
  getTankerbyID: (state) => (id)=> {
    return _.find(state.mpTankerAll,{"id": id}); 
  },
  getVesselByID: (state) => {
    return state.mpVessel; 
  },
  getMpTankerName: (state) => (id) => {
    const { mpTankerAll } = state;
    const tanker = _.find(mpTankerAll,{"id" : id });
    const name = _.get(tanker,"name");
    return name;
  },
  getMpVesselName: (state) => (id) => {
    const { mpVesselAll } = state;
    const mpVessels = _.find(mpVesselAll,{"id" : id });
    const name = _.get(mpVessels,"name");
    return name;
  },
  getTankerValue: (state) => () => {
    const { mpTankerValue } = state
    const volumes = _.get(mpTankerValue[0], "volumes");
    const total = _.sumBy(volumes,(volume) => {
      return parseInt(volume) 
    })
    return total;
  },
};

const actions = {
  getMpTankerByMMSI(context, params) {
    const mmsi = _.get(params, "mmsi", 0);
    $.ajax({
      url: `http://mp-new.excise-online.com/tankers.json?q[mmsi_eq]=${mmsi}`,
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: (result) => {
        const data = _.find(result, { mmsi });
        context.commit("SET_MP_TANKER_DETAIL_SUCCESS", { data });
      },
      error: (e) => {
        context.commit("SET_MP_TANKER_DETAIL_FAIL", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },
  getMpTankerVolume(context, params) {
    const start = _.get(params, "date.startDate", "");
    const end = _.get(params, "date.endDate", "");
    const statementGteq = moment(start, "DD/MM/YYYY").format("YYYY-MM-DD");
    const statementLteq = moment(end, "DD/MM/YYYY").format("YYYY-MM-DD");
    const mmsi = params.mmsi;
    const config = {
      params: {
        "q[departed_at_gt]": statementGteq,
        "q[departed_at_lt]": statementLteq,
        "q[vessel_loads_destination_type_eq]": params.destination_type,
        domestic: params.isDomestic,
        "q[workflow_state_cont]": "approved",
      },
      headers: {
        "X-User-Email": "api_truck@petrol.excise-online.com",
        "X-User-Token": "ofFd99ZSDTpKzxTeV-Ts",
      },
    };
    const url = Endpoint.vesselTrips();
    axios
      .get(url, config)
      .then((res) => {
        const values = res.data.filter((a) => {
          const { vessel } = a;
          if (vessel.mmsi == mmsi) {
            return true;
          }
          return false;
        });
        context.commit("SET_MP_VALUE_SUCCESS", { values });
      })
      .catch((e) => {
        context.commit("SET_MP_VALUE_FAIL", { error: e });
      });
  },
  getMpCapacityDetail(content, params) {
    const id = _.get(params, "id", 0);
    const start = _.get(params, "date.startDate", "");
    const end = _.get(params, "date.endDate", "");

    const statementGteq = moment(start, "DD/MM/YYYY").format("YYYY-MM-DD");
    const statementLteq = moment(end, "DD/MM/YYYY").format("YYYY-MM-DD");
    const st = `q[statement_date_gteq]=${statementGteq}`;
    const ed = `q[statement_date_lteq]=${statementLteq}`;
    $.ajax({
      url: `http://mp-new.excise-online.com/transfer_statements.json?q[tanker_id_eq]=${id}&${st}&${ed}`,
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token2}`);
      },
      success: (result) => {
        const data = result;
        content.commit("SET_MP_TANKER_CAPACITY_SUCCESS", { data });
      },
      error: (e) => {
        // error
        content.commit("SET_MP_TANKER_CAPACITY_FAIL", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },
  async getMpTankerAll(context) {
    await $.ajax({
      url: Endpoint.mpTankers(),
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: (result) => {
        const mpTankerAll = result;
        context.commit("SET_MP_TANKER_ALL_SUCCESS", { mpTankerAll });
      },
      error: (e) => {
        context.commit("SET_MP_TANKER_ALL_FAIL", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },
  async getMpVesselAll(context) {
    await $.ajax({
      url: Endpoint.mpVessels(),
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: (result) => {
        const mpVesselAll = result;
        context.commit("SET_MP_VESSEL_ALL_SUCCESS", { mpVesselAll });
      },
      error: (e) => {
        context.commit("SET_MP_TANKER_ALL_FAIL", { error: e });
      },
      complete: () => {
        // complete
      },
    });
  },
  async getMpVesselById(context, params) {
    // context.commit("SET_MP_VESSEL_NULL");
    const vessel_id = _.get(params, "vessel_id", 0);
    // console.log(vessel_id);
    await $.ajax({
      url: `http://mp-new.excise-online.com/vessels.json?q[id_eq]=${vessel_id}`,
      type: "GET",
      beforeSend: (xhr) => {
        xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      },
      success: async (result) => {
        const data = result.map((a) => {
          return {
            id: a.id,
            name: a.name,
            member_code: a.member_code,
          };
        });
        await context.commit("SET_MP_VESSEL_BY_ID", { data });
      },
      error: (e) => {
        context.commit("SET_MP_TANKER_DETAIL_FAIL", { error: e });
      },
      complete: () => {
      },
    });
  },
};

const mutations = {
  SET_MP_VESSEL_NULL(){
    state.mpVessel = [];
  },
  SET_MP_VESSEL_BY_ID(state, payload) {
    // state.mpVessel = payload.data;
    state.mpVessel.push(...payload.data);
    state.mpVessel = _.uniqBy(state.mpVessel, "id");
    // console.log(state.mpVessel);
  },
  SET_MP_VALUE_SUCCESS(state, payload) {
    state.mpTankerValue = payload.values;
  },
  SET_MP_VALUE_FAIL(state, payload) {
    state.error = payload.error;
  },
  SET_MP_TANKER_DETAIL_SUCCESS(state, payload) {
    state.mpTanker = payload.data;
  },
  SET_MP_TANKER_DETAIL_FAIL(state, payload) {
    state.error = payload.error;
  },
  SET_MP_TANKER_CAPACITY_SUCCESS(state, payload) {
    state.mpTankerCapacity = payload.data || {};
  },
  SET_MP_TANKER_CAPACITY_FAIL(state, payload) {
    state.error = payload.error;
  },
  SET_MP_TANKER_ALL_SUCCESS(state, payload) {
    state.mpTankerAll = payload.mpTankerAll;
  },
  SET_MP_VESSEL_ALL_SUCCESS(state, payload) {
    state.mpVesselAll = payload.mpVesselAll;
  },
  SET_MP_TANKER_ALL_FAIL(state, payload) {
    state.error = payload.error;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
